import { useCustomerContext } from "../../Context/CustomerContext";

export function useCustomerId() {
  const { customer } = useCustomerContext();
  return customer.id;
}
